export const getIsTrustWallet = (name: string | undefined): boolean =>
  name?.toLowerCase().includes('trust wallet') === true;
